const contentful = require("contentful");

const client = contentful.createClient({
  space: "t96depm2zp2s",
  accessToken: process.env.REACT_APP_CONTENTFUL_KEY,
});

export default client;
